import { COLLAPSED_ANNOTATIONS_COUNT } from '../constants.js';

function shouldHideAnnotation({
  row,
  isShowingAllAnnotations,
  rowCount
}) {
  if (isShowingAllAnnotations) {
    return false;
  }

  if (rowCount === COLLAPSED_ANNOTATIONS_COUNT) {
    return false;
  }

  if (rowCount > COLLAPSED_ANNOTATIONS_COUNT && row > COLLAPSED_ANNOTATIONS_COUNT - 1) {
    return true;
  }

  return false;
}

export { shouldHideAnnotation };
